<template>
	<router-view></router-view>
</template>

<script>
export default {
	name: 'housemaids',
};
</script>



// WEBPACK FOOTER //
// Housemaids.vue?71a4e660